import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e36cd404"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-container" }
const _hoisted_2 = { class: "drill-hole-inputs" }

import Length from "../../../source/js/shared/models/Geometry/Length";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ValidationMessage from "@/components/UI/ValidationMessage.vue";
import { endsWithSeparator, limitDecimals, stripNonNumeric, toNumber } from "@/functions/numbers";
import {computed, onBeforeUnmount, onMounted} from "vue";
import { useStore } from "vuex";
import {addSizeToDataLayer} from "@/functions/analytics";
import DrillHoleConfigurationFactory from "@/Models/DrillHoleConfigurations/DrillHoleConfigurationFactory";
import MessageContainer from "@/components/UI/MessageContainer.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DrillHoleGridSettings',
  setup(__props) {

const store = useStore();

const drillOption = computed(() => store.getters.drillOption );
const isDrillHoleValid = computed(() => store.getters.isDrillHoleValid );
const getDrillHoleValidationMessage = computed(() => store.getters.getDrillHoleValidationMessage );
const minimumDrillHoleDiameter = computed(() => store.getters.minimumDrillHoleDiameter );
const lastGeneratedConfiguration = computed(() => store.getters.lastGeneratedConfiguration );
const hasDrillHoleValidatorErrors = computed(() => store.getters.hasDrillHoleValidatorErrors );

const drillHoleDiameter = computed({
	get: () => store.getters.drillHoleDiameter.in_cm(),
	set: (value: string) => {
		if ( ! endsWithSeparator( value ) && value !== '' ) {
			store.commit("updateDrillHoleDiameter", Length.from_cm( limitDecimals( value, 1 ) ).in_mm() );
			store.commit("updateUsingDefaultDrillHoleDimensions", false );
		}
	},
});
const drillHoleHorizontalAmount = computed({
	get: () => store.getters.drillHoleHorizontalAmount,
	set: (value: number|string) => {
		if ( ! endsWithSeparator( value ) && value !== '' ) {
			store.commit("updateDrillHoleHorizontalAmount", toNumber(stripNonNumeric(value)));
			store.commit("updateUsingDefaultDrillHoleDimensions", false );
		}
	},
});
const drillHoleVerticalAmount = computed({
	get: () => store.getters.drillHoleVerticalAmount,
	set: (value: number|string) => {
		if ( ! endsWithSeparator( value ) && value !== '' ) {
			store.commit("updateDrillHoleVerticalAmount", toNumber(stripNonNumeric(value)));
			store.commit("updateUsingDefaultDrillHoleDimensions", false );
		}
	},
});
const drillHoleOffset = computed({
	get: () => store.getters.drillHoleOffset.in_cm(),
	set: (value: string) => {
		if ( ! endsWithSeparator( value ) && value !== '' ) {
			store.commit("updateDrillHoleOffset", Length.from_cm( limitDecimals( value, 1 ) ).in_mm() );
			store.commit("updateUsingDefaultDrillHoleDimensions", false );
		}
	},
});

document.addEventListener("focusin", focusChanged);

function focusChanged(event): void {
	store.commit("updateFocusedElement", event.target);
}

function drillHoleFieldsWithMessage(): {key: string, message: string}[] {
	const configuration = new DrillHoleConfigurationFactory().get_configuration( 'grid' );

	// filter out keys with valid dimensions
	const invalidKeys = configuration.get_input_keys().filter((field) => !isDrillHoleValid.value(field));

	// get the data we need to render a notice
	return invalidKeys.map((field) => {
		return {
			key: field,
			message: getDrillHoleValidationMessage.value(field),
		};
	});
}

onMounted(async () => {

	// Don't set defaults if we have an old configuration available for radial drill holes.
	if ( lastGeneratedConfiguration.value.drillholes?.type === 'grid' ) {
		return;
	}
});

onBeforeUnmount(() => {
	document.removeEventListener("focusin", focusChanged);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DimensionInput, {
        inputRef: "drillHoleHorizontalAmount",
        id: "drillHoleHorizontalAmount",
        name: "drillHoleHorizontalAmount",
        inputmode: "numeric",
        min: 1,
        max: 1000,
        label: _ctx.$i18n.drillHoleConfiguration.grid.holes_amount_horizontally,
        invalid: !isDrillHoleValid.value('drillHoleHorizontalAmount'),
        onBlur: () => _unref(addSizeToDataLayer)(_ctx.$i18n.drillHoleConfiguration.grid.holes_amount_horizontally, drillHoleHorizontalAmount.value, 'grid-drill-hole'),
        modelValue: drillHoleHorizontalAmount.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((drillHoleHorizontalAmount).value = $event)),
        step: 1
      }, null, 8, ["label", "invalid", "onBlur", "modelValue"]),
      _createVNode(DimensionInput, {
        inputRef: "drillHoleVerticalAmount",
        id: "drillHoleVerticalAmount",
        name: "drillHoleVerticalAmount",
        inputmode: "numeric",
        min: 1,
        max: 1000,
        label: _ctx.$i18n.drillHoleConfiguration.grid.holes_amount_vertically,
        invalid: !isDrillHoleValid.value('drillHoleVerticalAmount'),
        onBlur: () => _unref(addSizeToDataLayer)(_ctx.$i18n.drillHoleConfiguration.grid.holes_amount_vertically, drillHoleVerticalAmount.value, 'grid-drill-hole'),
        modelValue: drillHoleVerticalAmount.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((drillHoleVerticalAmount).value = $event)),
        step: 1
      }, null, 8, ["label", "invalid", "onBlur", "modelValue"]),
      _createVNode(DimensionInput, {
        inputRef: "drillHoleDiameter",
        id: "drillHoleDiameter",
        name: "drillHoleDiameter",
        unit: "cm",
        min: minimumDrillHoleDiameter.value,
        label: `${_ctx.$i18n.drillHoleConfiguration.diameter_drill_hole}`,
        invalid: !isDrillHoleValid.value('drillHoleDiameter'),
        onBlur: () => _unref(addSizeToDataLayer)(_ctx.$i18n.drillHoleConfiguration.diameter_drill_hole, drillHoleDiameter.value, 'grid-drill-hole'),
        modelValue: drillHoleDiameter.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((drillHoleDiameter).value = $event))
      }, null, 8, ["min", "label", "invalid", "onBlur", "modelValue"]),
      _createVNode(DimensionInput, {
        inputRef: "drillHoleOffset",
        id: "drillHoleOffset",
        name: "drillHoleOffset",
        unit: "cm",
        min: minimumDrillHoleDiameter.value,
        label: `${_ctx.$i18n.drillHoleConfiguration.distance_from_edge}`,
        invalid: !isDrillHoleValid.value('drillHoleOffset'),
        onBlur: () => _unref(addSizeToDataLayer)(_ctx.$i18n.drillHoleConfiguration.distance_from_edge, drillHoleOffset.value, 'grid-drill-hole'),
        modelValue: drillHoleOffset.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((drillHoleOffset).value = $event))
      }, null, 8, ["min", "label", "invalid", "onBlur", "modelValue"])
    ]),
    _createVNode(MessageContainer, null, {
      default: _withCtx(() => [
        (drillOption.value !== 'none')
          ? (_openBlock(), _createBlock(ValidationMessage, {
              key: 0,
              type: "notice"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$i18n.drillHolesNotice), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(drillHoleFieldsWithMessage(), (field) => {
          return (_openBlock(), _createBlock(ValidationMessage, {
            key: field.key + '-validation-message',
            "input-id": field.key
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(field.message), 1)
            ]),
            _: 2
          }, 1032, ["input-id"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})